module.exports = __webpack_public_path__ + "img/1476177944.702fab6f.jpg";